import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import "./Login.css";

function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const togglePassword = () => {
        setShowPassword((show) => !show);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // chiamata al backend Express
            const response = await fetch("/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password })
            });


            const data = await response.json();

            if (data.success) {
                // login riuscito → salvo stato e navigo
                sessionStorage.setItem("isAuthenticated", "true");
                navigate("/home");
            } else {
                // login fallito → mostro messaggio
                setError(data.message || "Credenziali errate");
            }
        } catch (err) {
            // errore di rete o server non raggiungibile
            setError("Errore di connessione al server");
        }
    };

    return (
        <div className="App">
            <div id="image"></div>
            <div id="login">
                <div id="logo">
                    <img
                        src={"logo-header.png"}
                        alt="Logo"
                    />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="data">
                        <p className="p_data">Username</p>
                        <input
                            className="i_data"
                            type="text"
                            placeholder="Inserisci il tuo username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="data">
                        <p className="p_data">Password</p>
                        <div id="password">
                            <input
                                className="i_data"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Inserisci la tua password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span onClick={togglePassword}>
                                {showPassword ? (
                                    <FaEyeSlash className="icon" />
                                ) : (
                                    <FaEye className="icon" />
                                )}
                            </span>
                        </div>
                    </div>
                    <div id="errore">
                        {error && <p id="errore_text">{error}</p>}
                    </div>
                    <div id="button_div">
                        <button id="button" type="submit">Accedi</button>
                    </div>
                </form>
                <div id="p_iva">
                    © 2024 IDEAHOME - P.I. 0353606043
                </div>
            </div>
        </div>
    );
}

export default Login;
